import { lazy, Suspense } from 'react'
import { useSelector } from 'react-redux'

// Role-based dashboard dispatcher.
// - Employees see a warm, personal EmployeeDashboard
// - Managers (+ users with subordinates) see ManagerDashboard with team widgets
// - HR / company_admin / super_admin see HRDashboard with company-wide metrics
// Honors `localStorage.hrms_active_view` so HR can switch to "personal" view.

const EmployeeDashboard = lazy(() => import('./dashboards/EmployeeDashboard'))
const ManagerDashboard = lazy(() => import('./dashboards/ManagerDashboard'))
const HRDashboard = lazy(() => import('./dashboards/HRDashboard'))

const HR_ROLES = ['super_admin', 'company_admin', 'hr_manager']
const MANAGER_ROLES = ['department_manager']

const pickDashboard = ({ role, hasSubordinates, activeView }) => {
  // Explicit active-view override (set by role switcher)
  if (activeView === 'personal' && role !== 'employee') return EmployeeDashboard
  if (activeView === 'team') return ManagerDashboard
  if (activeView === 'company' || activeView === 'system') return HRDashboard

  // Default by role
  if (HR_ROLES.includes(role)) return HRDashboard
  if (MANAGER_ROLES.includes(role) || hasSubordinates) return ManagerDashboard
  return EmployeeDashboard
}

const Dashboard = () => {
  const { user } = useSelector((s) => s.auth)
  const role = user?.role
  const hasSubordinates = Boolean(user?.has_subordinates)
  const activeView = typeof window !== 'undefined'
    ? (localStorage.getItem('hrms_active_view') || null)
    : null

  const DashComponent = pickDashboard({ role, hasSubordinates, activeView })

  return (
    <Suspense
      fallback={
        <div className="p-10 text-center text-gray-400 text-sm">載入儀表板…</div>
      }
    >
      <DashComponent />
    </Suspense>
  )
}

export default Dashboard
